import { VevProps } from '.';

export type VevDispatchEvent = {
  type?: string;
  contentKey?: string;
  args?: VevProps[];
};

export const NATIVE_TRIGGERS = [
  'onClick',
  'onMouseEnter',
  'onMouseLeave',
  'onDoubleClick',
] as const;

export const CUSTOM_TRIGGERS = ['onVisible', 'onScroll'] as const;

export enum GLOBAL_EVENT_TYPES {
  SHOW = 'SHOW',
  HIDE = 'HIDE',
  TOGGLE = 'TOGGLE_VISIBILITY',
}

export type VevTriggersCustom = typeof CUSTOM_TRIGGERS[number];
export type VevTriggersNative = typeof NATIVE_TRIGGERS[number];
export type VevTriggerType = VevTriggersNative | VevTriggersCustom | string;

export type VevTrigger = {
  type: VevTriggerType;
  contentKey: string;
  name?: string;
  condition?: string;
  args?: VevProps[];
};

export type ProjectInteraction = {
  key: string;
  event?: VevDispatchEvent;
  trigger?: VevTrigger;
  updated?: number;
  deleted?: number;
};
